"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

require("./SelectPowerBiReport.css");

var SelectPowerBiFileModal_1 = require("./SelectPowerBiFileModal");

var SelectPowerBiReportModal_1 = require("./SelectPowerBiReportModal");

var MODAL_FILE = 'MODAL_FILE';
var MODAL_REPORT = 'MODAL_REPORT';

var SelectPowerBiReport = function (_a) {
  var _b = _a.show,
      show = _b === void 0 ? true : _b,
      onHide = _a.onHide,
      onAdd = _a.onAdd,
      project = _a.project,
      engagementUrl = _a.engagementUrl,
      isLoading = _a.isLoading,
      reports = _a.reports,
      pageTitle = _a.pageTitle,
      height = _a.height,
      createPBILibraryItem = _a.createPBILibraryItem,
      powerBiReport = _a.powerBiReport,
      calcContentHeight = _a.calcContentHeight;

  var _c = (0, react_1.useState)(MODAL_FILE),
      activeView = _c[0],
      setActiveView = _c[1];

  var _d = (0, react_1.useState)(false),
      isShown = _d[0],
      setIsShown = _d[1];

  var _e = (0, react_1.useState)(),
      file = _e[0],
      setFile = _e[1];

  (0, react_1.useEffect)(function () {
    return setIsShown(show);
  }, [show]);

  var handleHide = function () {
    setIsShown(false);
    setActiveView(MODAL_FILE);
    onHide();
  };

  if (activeView === MODAL_FILE) {
    return (0, jsx_runtime_1.jsx)(SelectPowerBiFileModal_1.SelectPowerBiFileModal, {
      show: isShown,
      onHide: handleHide,
      fileSelected: function (selectedFile) {
        setFile(selectedFile);
        setActiveView(MODAL_REPORT);
      },
      project: project,
      engagementUrl: engagementUrl,
      isLoading: isLoading,
      reports: reports,
      pageTitle: pageTitle
    }, void 0);
  }

  if (activeView === MODAL_REPORT) {
    return (0, jsx_runtime_1.jsx)(SelectPowerBiReportModal_1.SelectPowerBiReportModal, {
      show: isShown,
      onHide: handleHide,
      file: file,
      onBack: function () {
        return setActiveView(MODAL_FILE);
      },
      onAdd: onAdd,
      height: height,
      engagementUrl: engagementUrl,
      createPBILibraryItem: createPBILibraryItem,
      pageTitle: pageTitle,
      powerBiReport: powerBiReport,
      calcContentHeight: calcContentHeight
    }, void 0);
  }

  return null;
};

exports.default = SelectPowerBiReport;